import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ChevronDown } from 'react-feather';

import FAQPropTypes from '../models/FAQ/FAQPropTypes';
import { colors, Text, Grid, animation } from '../ui-components';
import renderRichText from '../utils/render-rich-text';

const propTypes = {
  faq: FAQPropTypes,
  type: PropTypes.string,
  className: PropTypes.string
};

 /**
   * @component FaqQuestion
   * 
   * @param {object} props
   * 
   * @prop {object} faq
   * @prop {object} challenge
   * @prop {string} type
   * @prop {string} className
   * 
   * @return {JSX}
   */
const FaqQuestion = props => {
  const { faq, challenge, type = 'faq', className } = props;
  const [open, setOpen] = useState(false);
  const answerRef = useRef();

  const getAnswerHeight = () => {
    return answerRef?.current?.clientHeight;
  };

  const renderAnswer = () => {
    return <AnswerWrapper ref={answerRef}>{renderRichText(faq.answerRichJSON, null, 'medium')}</AnswerWrapper>;
  };

  return (
    <QuestionWrapper open={open} className={className}>
      <Question className={'faq-question'} onClick={() => setOpen(!open)}>
        <Text size="large">{faq?.question}</Text>
        <IconChevronDown open={open} aria-hidden />
      </Question>
      <HeightController open={open} answerHeight={getAnswerHeight()}>
        {renderAnswer()}
      </HeightController>
    </QuestionWrapper>
  );
};

const QuestionWrapper = styled.div`
  border-bottom: 1px solid ${colors.gray3};
  padding: 26px 16px;
  overflow: hidden;

  &[open] {
    .faq-question p {
      font-weight: 700;
    }
  }
`;

const Question = styled.button`
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding: 0;
  border: 0;
  background: transparent;
  width: 100%;
  outline: 0;
  text-align: left;
`;

const IconChevronDown = styled(ChevronDown)`
  align-self: center;
  flex-shrink: 0;
  margin-left: 24px;
  transform: ${({ open }) => (open ? 'rotate(-180deg)' : 'rotate(0deg)')};
  transition: transform ${animation.general.durationAndTiming};
`;

const HeightController = styled.div`
  max-height: ${({ open, answerHeight }) => (open ? answerHeight : 0)}px;
  opacity: ${({ open }) => (open ? 1 : 0)};
  transition: max-height ${animation.general.durationAndTiming}, opacity ${({ open }) => (open ? '0.2s' : '0.25s 0.1s')};
`;

const AnswerWrapper = styled.div`
  padding-top: 16px;

  p {
    &:last-of-type {
      margin-bottom: 0;
    }
  }
`;

const DescriptionWrapper = styled.div`
  margin-top: 20px;
  margin-bottom: 30px;
`;

const LinksGrid = styled(Grid)`
  margin-bottom: 10px;

  a {
    font-size: 14px;
    text-transform: capitalize;
  }
`;

const RelatedOfferings = styled.p`
  font-weight: 900;
  text-transform: uppercase;
  font-size: 16px !important;
  color: ${colors.gray2};
  margin-top: 40px;
  margin-bottom: 20px !important;
`;

FaqQuestion.propTypes = propTypes;

export default FaqQuestion;
